export default __webpack_public_path__ + "static/media/GitHub.c6d68473.svg";